module.exports = __webpack_public_path__ + "static/media/Griffin.d8fd7ecf.jpg";